import React, { useLayoutEffect, useRef } from 'react';

import { LOCALES } from 'locales';

import Image from '../../components/basic/Image';
import { getString } from '../../helpers/string-helpers';
import ArticleHeader from '../partials/blog/ArticleHeader';
import ArticleTOC from '../partials/blog/ArticleTOC';
import Authors from '../partials/blog/Authors';
import BlogEmailPopup from '../partials/blog/BlogEmailPopup';
import BlogHeader from '../partials/blog/BlogHeader';
import ExploreMore from '../partials/blog/ExploreMore';
import ShareSidebar from '../partials/ShareSidebar';
import SectionBuilder from '../SectionBuilder';

// import BlogExitPopup from '../partials/blog/BlogExitPopup';
//import EmailSignUp from '../partials/blog/EmailSignUp';

const getContent = (blocks) => {
  let content = '';

  for (const block of blocks) {
    content += block.attributes?.innerContent || '';
  }

  return content;
};

const getPostBlocksFiltered = (blocks, headerArr, footerArr, sideArr) => {
  // runs shallow check looking for blocks with special identifiers (we can use data.ids on the wrappers)
  const blocksObj = {
    body: [],
    footer: [],
    header: [],
    side: [],
  };
  for (const block of blocks) {
    const id = block?.attributes?.data?.id;
    if (headerArr.includes(id)) {
      blocksObj.header.push(block);
    } else if (sideArr.includes(id)) {
      blocksObj.side.push(block);
    } else if (footerArr.includes(id)) {
      blocksObj.footer.push(block);
    } else {
      blocksObj.body.push(block);
    }
  }

  return blocksObj;
};

export default class Single extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { meta } = this.props;
    if (meta?.post?.inlineScript) {
      eval(meta.post.inlineScript);
    }
  }

  render() {
    const {
      blocks,
      data,
      globals,
      meta,
      mode,
      modified,
      wp,
    } = this.props;

    const topicsData = meta?.topics;

    const {
      categories,
      date,
      excerpt,

      // status,
      slug,
      title: wpTitle,
    } = wp;

    const { image: seoImage, title: seoTitle } = meta?.seo || {};

    const { schema } = meta?.post || {};

    const theme = meta?.blogPostData?._colorTheme || 'light';
    const disablePopup = meta?.blogPostData?._disablePopup || false;

    const authors = meta.blogPostData._postAuthorsDetails;
    const title = meta.blogPostData.postTitle || wpTitle;

    const { sameCategoryPosts } = data;

    const postBlocks = getPostBlocksFiltered(
      blocks,
      ['post-header-block1'],
      ['post-footer-block1'],
      ['post-side-block1', 'post-side-block2']
    );

    const content = getContent(postBlocks.body);

    const url = `/blog/${slug}`;

    const modifiedDate = new Date(modified).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });

    let layoutToUse = 'no_image';

    if (meta?.blogPostData?._heroImageSrc) {
      layoutToUse = meta?.blogPostData?._heroImageLayout || 'half-width';
    }

    const articleHeaderData = {
      authors: authors,
      categories: categories,
      date: date,
      headerImage: meta?.blogPostData?._heroImageSrc || meta?.post?.headerImage,
      headerVideo: meta?.post?.headerVideo,
      heroImageArtist: meta?.blogPostData?._heroImageArtist,
      layout: layoutToUse,
      locale: mode.locale,
      modified: modifiedDate,
      reviewedBy: meta?.blogPostData?._reviewedBy,
      theme: theme,
      title: title,
    };

    const isBlogEmailPopupVisible = ['en-US', 'en-AU'].includes(mode.locale) && !disablePopup;

    // const isBlogExitPopupVisible = ['en-AU'].includes(mode.locale);

    const getSchema = (schema) => {
      schema = schema?.trim();

      if (!schema) {
        return (
          <script
            dangerouslySetInnerHTML={{
              __html: `
            {
              "@context": "http://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage":{
                "@type":"WebPage",
                "@id":"https://www.rippling.com${url}"
              },
              "headline": "${seoTitle}",
              "image": {
                "@type": "ImageObject",
                "url": "${seoImage}",
                "height": 750,
                "Width": 1200
              },
              "datePublished": "${date}",
              "dateModified": "${modified}",
              "author": {
                "@type": "Person",
                "name": "${authors ? authors[0].name : 'The Rippling Team'}"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Rippling",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://cdn.rippling.com/static/marketing/site-content/2021/04/rippling-logo-1.png",
                  "width": 300,
                  "height": 43
                }
              },
              "description": "${excerpt
            .replaceAll(/(<([^>]+)>)/gi, '')
            .replaceAll(/\r?\n/gi, '')
            .replaceAll('"', String.raw`\"`)}",
              "articleBody": "${content
            .replaceAll(/(<([^>]+)>)/gi, '')
            .replaceAll(/\r?\n/gi, '')
            .replaceAll('"', String.raw`\"`)}"
            }
          `,
            }}
            type="application/ld+json"
          />
        );
      }
    };

    const ArticleSide = ({ children }) => {
      const scrollContainer = useRef(null);

      useLayoutEffect(() => {
        const resizeHandler = () => {
          if (window.innerWidth >= 1300) {
            if (scrollContainer?.current) {
              scrollContainer.current.style.height = `${
                window.innerHeight - 80 - 120 + 40
              }px`;
            }
          } else if (scrollContainer?.current) {
            scrollContainer.current.style.height = '100%';
          }
        };

        window.addEventListener('resize', resizeHandler);
        resizeHandler();
      }, []);

      return (
        <div
          className="ArticleSide z-1000 relative sm:max-w-725 blog-lg:max-w-350 max-w-100% w-100% px-0 sm:px-20 md:px-0 "
        >
          <div className="sticky top-120">
            <div
              ref={scrollContainer}
              className="hideScrollBars overflow-x-hidden overflow-y-auto"
            >
              {children}
            </div>
          </div>
        </div>
      );
    };

    const ArticleSideCTA = (locale) => {
      if (locale === 'en-AU') {
        return (
          <div className="bg-tertiary-gray1 rounded-8 overflow-hidden my-40">
            <div className="flex flex-col">
              <Image
                attributes={{
                  mediaURL: 'https://rippling2.imgix.net/sidebar-au-cta.png',
                  nonResponsive: true,
                }}
              />
              <div className="p-32">
                <div className="flex flex-col justify-center max-w-[360px]">
                  <h4 className="text-plum-800 mb-8">2025 Australian Payroll & Hiring Intelligence Pack</h4>
                  <p className="text-plum-800 opacity-70 is-style-p2 pb-10">Get immediate access to:</p>
                </div>
                <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-10 ">
                  <div className="imagex w-24 h-24 shrink-0 flex items-center ">
                    <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
                  </div>
                  <p className="text-plum-800 is-style-p2 opacity-70 ">Compliance trends reshaping Australian payroll</p>
                </div>
                <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-10 ">
                  <div className="imagex w-24 h-24 shrink-0 flex items-center ">
                    <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
                  </div>
                  <p className="text-plum-800 is-style-p2 opacity-70 ">Industry benchmarks and salary insights</p>
                </div>
                <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-10">
                  <div className="imagex w-24 h-24 shrink-0 flex items-center ">
                    <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
                  </div>
                  <p className="text-plum-800 is-style-p2 opacity-70 ">Strategic recommendations for FY25</p>
                </div>
                <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-10">
                  <div className="imagex w-24 h-24 shrink-0 flex items-center ">
                    <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
                  </div>
                  <p className="text-plum-800 is-style-p2 opacity-70 ">Productivity forecasts for FY25</p>
                </div>
                <div className="wrapper flex gap-8 items-start sm:items-center justify-left">
                  <div className="imagex w-24 h-24 shrink-0 flex items-center ">
                    <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
                  </div>
                  <p className="text-plum-800 is-style-p2 opacity-70 ">Expert analysis of hiring trends</p>
                </div>
              </div>
              <SectionBuilder
                blocks={[
                  {
                    attributes: {
                      campaign_name: '',
                      className:
                  'blog-popup-form-container px-32 -bg-white basic-hero-input-form w-100% flex max-w-350 flex-col rounded-4',
                      customOnSuccess2: 'window.open("/blog-thank-you","_blank");',
                      data: {},
                      formType: 'content',
                      hiddenInputs: {
                        Form_Type__c: 'Content',
                        Last_Lead_Origin__c:
                    '701Ud00000HhaeMIAR',
                      },
                      isSimpleSubmit: false,
                      redirectTo: '/blog-thank-you',
                    },
                    innerBlocks: [
                      {
                        attributes: {
                          className: 'w-100%',
                          data: {},
                          innerClassName: 'rounded-4 overflow-hidden',
                          label: 'Email address',
                          name: 'user_email',
                          onClick: () => {
                            window.dataLayer.push({
                              event: 'email_form_clicked',
                              modal_name: 'Blog Email Popup',
                            });
                          },
                          placeholder: 'Enter your email',
                          showError: false,
                          type: 'email',
                        },
                        name: 'field2',
                      },
                      {
                        attributes: {
                          className: 'flex rounded-4 w-100%',
                          data: {},
                          value: 'Unlock your first report',
                        },
                        name: 'submit',
                      },
                    ],
                    name: 'form-2',
                  },
                ]}
              />
              <p className="leading-14 text-10 text-plum-800 mt-12 max-w-350 px-32 pb-32">
                <span className="opacity-70">By clicking &ldquo;Unlock your first report,&rdquo; you agree to the use of your data in
                  accordance with Rippling&rsquo;s&nbsp;
                </span>
                <a
                  className="border-b-1
            hover:text-secondary-blue transition duration-300 whitespace-nowrap ease-in-out hover:border-secondary-blue"
                  href="https://app.rippling.com/legal/privacy"
                  rel="noreferrer"
                  target="_blank"
                >
                  Privacy Notice
                </a>
                <span className="opacity-70">, including for marketing purposes.</span>
              </p>
            </div>
          </div>
        );
      } else {
        return (
          <a
            className="hidden blog-lg:block btn bg-yellow px-38 py-10 rounded-2 w-100% max-w-100% blog-lg:max-w-300 mt-24"
            href="/request-demo"
          >
            <span>See Rippling</span>
          </a>
        );
      }
    };

    return (
      <>
        <BlogHeader
          {...globals.header}
          locale={mode.locale}
          search=""
          setSearch={null}
          theme={theme}
          topics={topicsData}
        />
        <main className="blogSingle pt-80 md:pt-[90px] bg-plum">
          <article
            className={`blogArticle ${
              meta?.blogPostData?._shouldUseTableOfContents?.[0] ||
              postBlocks?.side?.length
                ? '-with-toc'
                : ''
            }`}
          >
            <ArticleHeader {...articleHeaderData} />

            <div className="relative bg-white">
              <div className="blogArticle__container hidden md:flex">
                {meta?.blogPostData?._shouldUseTableOfContents?.[0] ||
                postBlocks?.side?.length ? (
                    <ArticleSide>
                      {meta?.blogPostData?._shouldUseTableOfContents?.[0] && (
                        <ArticleTOC
                          locale={mode.locale}
                          {...{
                            chapterTag: 'h3',
                            targetClass: 'blogArticle__content',
                          }}
                        />
                      )}
                      {postBlocks?.side?.length ? (
                        <div
                          className={`${
                            meta?.blogPostData?._shouldUseTableOfContents?.[0]
                              ? 'mt-48'
                              : ''
                          }`}
                        >
                          <SectionBuilder
                            blocks={postBlocks.side}
                            locale={LOCALES.EN_US}
                          />
                        </div>
                      ) :
                        ArticleSideCTA(mode.locale)
                      }
                    </ArticleSide>
                  ) : (
                    <ShareSidebar
                      title={title}
                      url={`https://www.rippling.com${url}`}
                    />
                  )}
              </div>
              <div className="blogArticle__content">
                <SectionBuilder blocks={postBlocks.body} />
                <div className="wrapper grid max-w-100% mx-auto pb-48 sm:max-w-725 md:px-20 px-0 font-medium font-display opacity-60 text-11 tracking-125 leading-16 uppercase">
                  {getString('lastEditText', mode.locale)}:{' '}
                  {new Date(modified).toLocaleDateString(undefined, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </div>
              </div>
            </div>
          </article>

          <Authors {...{ authors: authors }} locale={mode.locale} />

          {/* <EmailSignUp {...{
            title: `Future state: Newsletter sign-up`,
            description : `Not something we have the infrasture for now, but would be ideal to support for future content initiatives.`,
            showSocial : false,
            backgroundDrop : true,
            formId : ``
          }} /> */}
          {(sameCategoryPosts ?? []).length > 0 &&
            <ExploreMore locale={mode.locale} posts={sameCategoryPosts} />
          }

          {/* TODO Pick One? WWW-502 Ticket */}
          {isBlogEmailPopupVisible && <BlogEmailPopup />}
          {/* {isBlogExitPopupVisible && <BlogExitPopup />} */}

          {getSchema(schema)}
        </main>
      </>
    );
  }
}
